import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as urls from '../utility/urls';
@Injectable()
export class TagsService {
  constructor(private http: HttpClient) {}

  getTags(
    id_busqueda: string,
    categoria: string,
    institucion?: string,
    limite?: number
  ): Observable<any> {
    const data: any = {};
    data.buscar = id_busqueda;
    data['institucion'] = institucion;
    data.limite = limite;
    if (categoria) {
      data.categoria = categoria;
    }
    return this.http.post<any>(
      environment.rediApi + urls.getTags + urls.tagsInstitucionales,
      data
    );
  }
}
